module.exports = __webpack_public_path__ + "static/media/declare_frameIcon.4726782b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/declare_frameIcon.svg
// module id = 541
// module chunks = 0